import React, { useRef, useEffect } from 'react';

/**
 * Textarea that automatically grows in height to show all content.
 * Users never have to manually resize to see what they typed.
 */
const AutoResizeTextarea = ({
  value = '',
  minHeight = 80,
  maxHeight = 400,
  className = '',
  ...props
}) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    const height = Math.min(Math.max(el.scrollHeight, minHeight), maxHeight);
    el.style.height = `${height}px`;
    el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden';
  }, [value, minHeight, maxHeight]);

  return (
    <textarea
      ref={ref}
      value={value}
      className={className}
      style={{ resize: 'none', minHeight: `${minHeight}px`, boxSizing: 'border-box' }}
      {...props}
    />
  );
};

export default AutoResizeTextarea;
